import React from 'react'
import { countDuplicatesItemArray, removeItemArray } from '../../helpers/arrayFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { carritoDeleteItemAction, startItemAddNewAction } from '../../actions/carritoActions';

import './carrito-styles.css';

export const Item = ({ item }) => {

  const dispatch = useDispatch();

  const { carritoItems } = useSelector( state => state.carrito);

  const handleClickDecrease = () => {
    console.log(item);
    
    const result = removeItemArray( carritoItems, item );
    localStorage.setItem('items', JSON.stringify( result ) );

    dispatch(carritoDeleteItemAction(result));

    console.log(result);
    
  }

  const handleClickIncrease = () => {
    console.log(item);

    const quantity = countDuplicatesItemArray( item.codigo, carritoItems ); // Cuenta los items duplicados en el carrito

    dispatch( startItemAddNewAction( {
      ...item,
      cant: quantity
    } ));
    
  }

  const handleClickDeleteItem = () => {
    console.log(item);

    const result = carritoItems.filter( itm => itm.codigo !== item.codigo );
    localStorage.setItem('items', JSON.stringify( result ) );

    dispatch(carritoDeleteItemAction(result));
    // console.log(result);
    
    
  }
  
  return (
    <>
    
      {/* <li className="list-group-item d-flex justify-content-between">
          <span className="align-self-center">{item.desc}</span> 
          <span className="align-self-center">{item.cant}</span>
          <span className="align-self-center">{item.costo.toFixed(2)}</span>
          <button className="btn btn-danger" onClick={ handleClickIncrease }>+</button>
          <button className="btn btn-danger" onClick={ handleClickDecrease }>-</button>
          <button className="btn btn-danger" onClick={ handleClickDeleteItem }>borrar</button>
      </li> */}

     
                {/* <div className="card-body cart">
                    <div className="row cart-item mb-3">
                        <div className="col-md-2">
                            <div className="icon-cart-box">
                              <svg viewBox="0 0 576 512" width={20} height={20} xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" fill="#009688" />
                              </svg>
                            </div>
                        </div>
                        <div className="col-md-5 align-self-center">
                            <h5 className="card-title">{item.desc}</h5>
                            <p className="text-muted">Category: </p>
                        </div>
                       
                          <div className="col-md-2">
                              <div className="quantity">
                                <button onClick={ handleClickDecrease }>
                                  <svg fill="none" viewBox="0 0 24 24" height={14} width={14} xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="2.5" stroke="#47484b" d="M20 12L4 12" />
                                  </svg>
                                </button>
                                <label id='cantidad'>{ item.cant }</label>
                                <button onClick={ handleClickIncrease }>
                                  <svg fill="none" viewBox="0 0 24 24" height={14} width={14} xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="2.5" stroke="#47484b" d="M12 4V20M20 12H4" />
                                  </svg>
                                </button>
                              </div>
                          </div> */}

                            {/* <div className="input-group">
                                <button className="btn btn-outline-secondary btn-sm" onClick={ handleClickDecrease } type="button">-</button>
                                <span type="text" className="form-control form-control-sm text-center quantity-input max-width:100px" >{item.cant}</span>
                                <button className="btn btn-outline-secondary btn-sm" onClick={ handleClickIncrease } type="button">+</button>
                            </div> */}

                       
                        {/* <div className="col-md-2 text-end">
                            <p className="fw-bold">$ {item.costo}</p>
                            
                        </div>
                        <div className="col-md-1 text-end">
                              <button className="btn btn-sm btn-outline-danger" onClick={ handleClickDeleteItem }>
                                <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trash-2">
                                  <path d="M3 6h18" />
                                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                                  <line x1={10} x2={10} y1={11} y2={17} />
                                  <line x1={14} x2={14} y1={11} y2={17} />
                                </svg>
                            </button>
                        </div>
                    </div> */}
                    {/* <hr /> */}
                   
                {/* </div> */}
          
    <div className="cart-item cart">
        <div className="d-flex">
            {/* <img src="https://via.placeholder.com/60" alt="Product" className="product-img me-3" /> */}
            <div className='product-img me-3'>
              <div className="icon-cart-box">
                <svg viewBox="0 0 576 512" width={20} height={20} xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" fill="#009688" />
                </svg>
              </div>
            </div>
            <div>
                <h6>{item.desc}</h6>
                {/* <p className="text-muted">Category: </p> */}
                <div className="quantity">
                  <button onClick={ handleClickDecrease }>
                    <svg fill="none" viewBox="0 0 24 24" height={14} width={14} xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="2.5" stroke="#47484b" d="M20 12L4 12" />
                    </svg>
                  </button>
                  <label id='cantidad'>{ item.cant }</label>
                  <button onClick={ handleClickIncrease }>
                    <svg fill="none" viewBox="0 0 24 24" height={14} width={14} xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinejoin="round" strokeLinecap="round" strokeWidth="2.5" stroke="#47484b" d="M12 4V20M20 12H4" />
                    </svg>
                  </button>
                </div>
            </div>
        </div>
        

        <div className='row'>
        <div className="col-md-7 text-end">

          <span>{item.costo}</span>
        </div>
          <div className="col-md-1 text-end">

            <div className="col-md-1 text-end">
                  <button className="btn btn-sm btn-outline-danger" onClick={ handleClickDeleteItem }>
                    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trash-2">
                      <path d="M3 6h18" />
                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                      <line x1={10} x2={10} y1={11} y2={17} />
                      <line x1={14} x2={14} y1={11} y2={17} />
                    </svg>
                </button>
            </div>
          </div>
        </div>
    </div>
      
    </>
  )
}
